import { PARAMS_KEYS_FOR_TESTING_NODE } from './transactional-emails.const';
export const getTestDialogParams = (actionParams, service, action, editNode, testingUserEmail) => ({
	title: 'Send test email',
	testBtnText: 'Send',
	replaceParams: actionParams.filter((param) => PARAMS_KEYS_FOR_TESTING_NODE.includes(param.key)),
	service,
	action,
	node: { ...editNode, params_map: { to: testingUserEmail } },
});
